export default __webpack_public_path__ + "static/media/hht2_home_img_EP15.9a2e57ef.png";